import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { customHeaders, supersetUrl } from '../../../../../../Containers/Config/index.js';
import { SUPERSET_TOTAL_CSAT_SUBMITTED, SUPERSET_TOTAL_CSAT_SUBMITTED_ERROR, SUPERSET_TOTAL_CSAT_SUBMITTED_SUCCESS } from '../../../../actionType.js';
import apiCall from '../../../../apiCall.js';

function* supersetTotalCSATSubmitted({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${supersetUrl}/api/v1/chart/data`,
      method: 'POST',
      headers: {
        ...filteredHeaders,
        ...payload?.headers,
      },
      data: payload?.data,
    });

    if (response.status === 200) {
      yield put({
        type: SUPERSET_TOTAL_CSAT_SUBMITTED_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: SUPERSET_TOTAL_CSAT_SUBMITTED_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: SUPERSET_TOTAL_CSAT_SUBMITTED_ERROR, payload: error });
  }
}

export function* watchSupersetTotalCSATSubmitted() {
  yield takeEvery(SUPERSET_TOTAL_CSAT_SUBMITTED, supersetTotalCSATSubmitted);
}

function* supersetTotalCSATSubmittedSaga() {
  yield all([fork(watchSupersetTotalCSATSubmitted)]);
}

export default supersetTotalCSATSubmittedSaga;
